import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { voidRemitSettings } from '../api/remit-settings.ts';

export default function useVoidRemitSetting(): UseMutationResult<
  string,
  Error,
  string
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => voidRemitSettings(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['remitSettings'] });
    },
  });
}
